import React, { useState, useRef } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";
import "../../style/Login.css";

import { useToasts } from "react-toast-notifications";
import { Helmet } from "react-helmet";
import ReCAPTCHA from "react-google-recaptcha";

const API_URL = process.env.REACT_APP_API_URL;
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_KEY;

function SignUp() {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [passwordbis, setPasswordbis] = useState("");
  const [email, setEmail] = useState("");
  const [disabledBtn, setDisabledBtn] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const roles = "ROLE_USER";
  const { addToast } = useToasts();
  const reRef = useRef();

  const loginField = (event) => {
    setLogin(event.target.value);
  };
  const passwordField = (event) => {
    setPassword(event.target.value);
  };
  const passwordBisField = (event) => {
    setPasswordbis(event.target.value);
  };
  const emailField = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisabledBtn(true);
    const tokenCaptcha = await reRef.current.executeAsync();

    axios
      .post(`${API_URL}/api/auth/newuser`, {
        login,
        password,
        email,
        roles,
        tokenCaptcha,
      })
      .then((res) => {
        if (res.status === 201) {
          addToast(res.data.flash, {
            appearance: "success",
            autoDismiss: true,
          });
          setRedirect(true);
        }
      })
      .catch((err) =>
        addToast(`Erreur : ${err.response.data.flash}`, {
          appearance: "error",
          autoDismiss: true,
        })
      );
  };

  return (
    <div className="loginContainer">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Créez votre compte</title>
      </Helmet>
      <h1>Créer votre compte Monocle</h1>
      {redirect && <Redirect to="/login" />}
      <form onSubmit={handleSubmit} className="loginContainer2">
        Identifiant :
        <input
          type="text"
          placeholder="Identifiant"
          value={login}
          onChange={loginField}
          required
        />
        Adresse email :
        <input
          type="email"
          placeholder="Adresse mail"
          value={email}
          onChange={emailField}
          required
        />
        Mot de passe (8 caractères minimum):
        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={passwordField}
          required
        />
        Confirmation du mot de passe :
        <input
          type="password"
          placeholder="Confirmation du mot de passe"
          value={passwordbis}
          onChange={passwordBisField}
          required
        />
        <button
          type="submit"
          className="btn"
          value="submit"
          disabled={
            password === passwordbis && password.length >= 7
              ? disabledBtn
              : true
          }
        >
          Valider
        </button>
      </form>
      <ReCAPTCHA sitekey={SITE_KEY} size="invisible" ref={reRef} hl="fr" />
    </div>
  );
}

export default SignUp;
